__turbopack_context__.v({
  "content": "news-card-module__ZxCj5W__content",
  "date": "news-card-module__ZxCj5W__date",
  "image": "news-card-module__ZxCj5W__image",
  "imgWpr": "news-card-module__ZxCj5W__imgWpr",
  "title": "news-card-module__ZxCj5W__title",
  "type": "news-card-module__ZxCj5W__type",
  "wrapper": "news-card-module__ZxCj5W__wrapper",
});
